import { UNSUPPORTED_PAYMENTS } from '@/core/data/constants/unsupportedPayments';

export { UNSUPPORTED_PAYMENTS };

// CyberSourcePaymentSystem is a PSP system-level policy, not a user-facing payment method
// RemoteSales is an internal/CSR payment method, not available for end users
export const UNSUPPORTED_PAYMENTS_CHECKOUT_PROFILES = [
	...UNSUPPORTED_PAYMENTS,
	'CyberSourcePaymentSystem',
	'RemoteSales',
];
